export const BLOCKLIST_CHARACTER_LIMIT = 150;
